import { render, staticRenderFns } from "./PanelCampaignsComponent.vue?vue&type=template&id=3ad0a585"
import script from "./PanelCampaignsComponent.vue?vue&type=script&lang=js"
export * from "./PanelCampaignsComponent.vue?vue&type=script&lang=js"
import style0 from "./PanelCampaignsComponent.vue?vue&type=style&index=0&id=3ad0a585&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports